import { useEffect, useState } from "react";
import FrequenciaParques from "./componentes/frequenciaParques";
import ParquesMunicipais from "./componentes/ParqueMunicipais";
import ArborizacaoUrbana from "./componentes/ArborizacaoUrbana";
import FaunaPreservacao from "./componentes/FaunaPreservacao";
import MobilidadeSustentavel from "./componentes/mobilidadeSustentavel";

export default function ConquistasInternas({ subStep }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/conquistas-gestao/`);

        const json = await res.json();
        setData(json);
      } catch (error) {
        console.error("Erro ao buscar conquistas:", error);
      }
    }

    fetchData();
  }, []);

  const imagens = data || [];

  const getImagem = (index) => {
    if (!imagens[index]?.imagem) return "";

    return `${process.env.REACT_APP_API_URL}${imagens[index].imagem}`;
  };

  switch (subStep) {
    case 1:
      return <FrequenciaParques getImagem={getImagem} />;

    case 2:
      return <ParquesMunicipais getImagem={getImagem} />;

    case 3:
      return <ArborizacaoUrbana getImagem={getImagem} />;

    case 4:
      return <FaunaPreservacao getImagem={getImagem} />;

    case 5:
      return <MobilidadeSustentavel getImagem={getImagem} />;

    default:
      return null;
  }
}
